<template>
  <div class="container is-fluid">
      <div class="columns">
        <div class="column" style="margin: 0px 15%; font-family: Helvetica">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">Contact</p>
              <p class="subtitle has-text-white">
                
<br/><br/>
              <ul>
              <li><a href="https://www.facebook.com/emanuele.viscuso.14">Facebook</a></li>
              <li><a href="https://www.instagram.com/viscusology/?hl=en">Instagram</a></li>
              <li><a href="https://www.pinterest.fr/emanueleviscuso/_created/">Pinterest</a></li>
              </ul>
              </p>
            </div>
          </section>
          <h2 class="abouttext">
            <h3>
              mail : EmanueleViscuso@gmail.com
              <br/><br/>
              Phone Mexico : +525546791003
           </h3>
              <br/><br/><br/><br/>
          </h2>
        </div>
        <div class="column" style="min-height: 500px">
          <img
          class="bigimage"
            src="images2/fotoViscuso2capIparIV.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          
        </div>
        
      </div>
    </div>
</template>

<script>
export default {
  name: "Music",
  components: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #1c1011;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: justify;
}

h1 {
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
